import React from "react";
import { useSelector } from "react-redux";
import { selectJobDetailsSection, selectGeneralStation } from "../../../redux/selectors";

const PrintSkid = () => {
  const skidDetails = useSelector((state) =>
    selectJobDetailsSection(state, "skidConstruction")
  );
  const generalSpecsDetails = useSelector(selectGeneralStation);
  const activetab = useSelector((state) => state.activeMechanicalTab.selectedZone);

  const stationColor = generalSpecsDetails.find((detail) => detail.Zone === activetab)?.Color || "";

  const isZoneEmpty = (detail) => {
    return (
      !detail.SkidConstruction &&
      !detail.MustFitInShippingContainer &&
      !detail.CustomSkidConstructionDetailss &&
      !detail.LiftingPoints &&
      !detail.AdditionalSkidForVMS &&
      !detail.CoatingForSkid &&
      !detail.SkidColor &&
      !detail.SpecialCoatingUnderSkid &&
      !detail.LevelingKit &&
      !detail.SkidComments
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    return (
      <div>
        {details
          .filter((detail) => detail && detail.HasSkid && Object.keys(detail).length > 0)
          .map((detail, index) => {
            if (isZoneEmpty(detail)) {
              return null;
            }
            return (
              <div className="section" key={index}>
                <table className="table table-bordered full-width">
                  <tbody>
                    <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                    <tr>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Skid Construction: </strong>{detail.SkidConstruction}</td></tr>
                            <tr><td><strong>Must Fit In Shipping Container: </strong>{detail.MustFitInShippingContainer}</td></tr>
                            <tr><td><strong>Custom Skid Construction Details: </strong>{detail.CustomSkidConstructionDetailss}</td></tr>
                            <tr><td><strong>Lifting Points: </strong>{detail.LiftingPoints}</td></tr>
                            <tr><td><strong>Additional Skid For VMS: </strong>{detail.AdditionalSkidForVMS}</td></tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Coating For Skid: </strong>{detail.CoatingForSkid}</td></tr>
                            <tr>
                              <td>
                                <strong>Skid Color: </strong>
                                {detail.SkidColor === "Same as Station" ? `Same as Station (${stationColor})` : detail.SkidColor}
                              </td>
                            </tr>
                            <tr><td><strong>Special Coating Under Skid: </strong>{detail.SpecialCoatingUnderSkid}</td></tr>
                            <tr><td><strong>Leveling Kit: </strong>{detail.LevelingKit}</td></tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p><strong>Comments:</strong><br />{detail.SkidComments}</p>
                <br className="clearfix" />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div>
      {skidDetails && skidDetails.some(detail => detail.HasSkid) && <h2 className="print-section-header">Skid Construction Summary</h2>}
      {renderDetails(skidDetails)}
    </div>
  );
};

export default PrintSkid;
